import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type CreateProvingMutationVariables = {
  input: Types.ProvingInsertType
};


export type CreateProvingMutation = (
  { __typename?: 'Mutation' }
  & { createProving: (
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_id' | 'type' | 'id' | 'status' | 'title' | 'description' | 'dateTo' | 'dateFrom' | 'created'>
    & { responsible: Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id'>
    )> }
  ) }
);

export type ReadProvingsQueryVariables = {
  search?: Types.Maybe<Types.Scalars['String']>
};


export type ReadProvingsQuery = (
  { __typename?: 'Query' }
  & { provings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_deleted' | 'id' | '_id' | 'type' | 'status' | 'title' | 'description' | 'dateTo' | 'dateFrom' | 'created' | 'department'>
    & { maintenanceHead: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    )>>, createdBy: (
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    ), editor: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    )>>, responsible: Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    )>, resourceManager: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    )>>, provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title' | 'countryCode'>
    )> }
  )> }
);

export const CreateProvingDocument = gql`
    mutation CreateProving($input: ProvingInsertType!) {
  createProving(input: $input) {
    _id
    type
    id
    status
    title
    description
    dateTo
    dateFrom
    created
    responsible {
      _id
    }
  }
}
    `;
export type CreateProvingMutationFn = ApolloReactCommon.MutationFunction<CreateProvingMutation, CreateProvingMutationVariables>;

    export function useCreateProvingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProvingMutation, CreateProvingMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateProvingMutation, CreateProvingMutationVariables>(CreateProvingDocument, baseOptions);
    };
export type CreateProvingMutationHookResult = ReturnType<typeof useCreateProvingMutation>;
export type CreateProvingMutationResult = ApolloReactCommon.MutationResult<CreateProvingMutation>;
export type CreateProvingMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProvingMutation, CreateProvingMutationVariables>;
export const ReadProvingsDocument = gql`
    query ReadProvings($search: String) {
  provings(filter: {OR: [{title: {REGEX: $search, OPTIONS: "i"}}, {id: {REGEX: $search, OPTIONS: "i"}}, {department: {REGEX: $search, OPTIONS: "i"}}], status: {NIN: [8, 9, 10]}}) {
    _deleted
    id
    _id
    type
    status
    title
    description
    dateTo
    dateFrom
    created
    department
    maintenanceHead {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
    createdBy {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
    editor {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
    responsible {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
    resourceManager {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
    provingGround {
      _id
      title
      countryCode
    }
  }
}
    `;

    export function useReadProvingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadProvingsQuery, ReadProvingsQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadProvingsQuery, ReadProvingsQueryVariables>(ReadProvingsDocument, baseOptions);
    };
      export function useReadProvingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadProvingsQuery, ReadProvingsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadProvingsQuery, ReadProvingsQueryVariables>(ReadProvingsDocument, baseOptions);
      };
      
export type ReadProvingsQueryHookResult = ReturnType<typeof useReadProvingsQuery>;
export type ReadProvingsQueryResult = ApolloReactCommon.QueryResult<ReadProvingsQuery, ReadProvingsQueryVariables>;